import { render } from "./ValidatorPerformanceChart.vue?vue&type=template&id=1ccd5125&scoped=true"
import script from "./ValidatorPerformanceChart.vue?vue&type=script&lang=js"
export * from "./ValidatorPerformanceChart.vue?vue&type=script&lang=js"

import "./ValidatorPerformanceChart.vue?vue&type=style&index=0&id=1ccd5125&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ccd5125"],['__file',"resources/js/components/ValidatorPerformanceChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ccd5125"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ccd5125', __exports__)) {
    api.reload('1ccd5125', __exports__)
  }
  
  module.hot.accept("./ValidatorPerformanceChart.vue?vue&type=template&id=1ccd5125&scoped=true", () => {
    api.rerender('1ccd5125', render)
  })

}


export default __exports__